import React, { useState } from "react";
import { Drawer, Button, Descriptions, Tooltip, Typography } from "antd";

const { Text } = Typography;

const GenericViewDrawer = ({
  isVisible,
  handleCancel,
  title,
  data, // Data object to display
  footerButtons = ["Close"], // Customizable footer buttons
  onButtonClick, // Function to handle button clicks
}) => {
  const [isDescriptionDrawerVisible, setIsDescriptionDrawerVisible] = useState(false);
  const [fullDescription, setFullDescription] = useState("");

  // Handle opening and closing the description drawer
  const handleDescriptionDrawer = (description) => {
    setFullDescription(description);
    setIsDescriptionDrawerVisible(true);
  };

  // Helper function to truncate long descriptions
  const truncateText = (text, maxLength = 20) => {
    const words = text.split(" ");
    if (words.length > maxLength) {
      return (
        <>
          {words.slice(0, maxLength).join(" ")}...
          <a onClick={() => handleDescriptionDrawer(text)} style={{ cursor: "pointer" }}>
            {" "}
            Read more
          </a>
        </>
      );
    }
    return text;
  };

  // Render nested table for department or other nested objects
  const renderNestedTable = (nestedData) => (
    <Descriptions bordered column={1} size="small">
      {Object.keys(nestedData)
        .filter((nestedKey) => nestedKey !== "id" && nestedKey !== "createdAt" && nestedKey !== "updatedAt")
        .map((nestedKey) => (
          <Descriptions.Item
            key={nestedKey}
            label={nestedKey.charAt(0).toUpperCase() + nestedKey.slice(1)}
          >
            {nestedData[nestedKey]}
          </Descriptions.Item>
        ))}
    </Descriptions>
  );

  const renderNestedContent = (value) => {
    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        // Render each item in the array
        return value.map((item, index) => (
          <div key={index} style={{ marginLeft: 20 }}>
            {renderNestedContent(item)}
          </div>
        ));
      } else {
        // Render nested object as a table
        return (
          <Descriptions bordered column={1} size="small">
            {Object.keys(value).map((nestedKey) => (
              <Descriptions.Item
                key={nestedKey}
                label={nestedKey.charAt(0).toUpperCase() + nestedKey.slice(1)}
              >
                {renderNestedContent(value[nestedKey])}
              </Descriptions.Item>
            ))}
          </Descriptions>
        );
      }
    }
    return value;
  };
  
  const renderDescriptionItems = () => {
    return data
      ? Object.keys(data).map((key) => {
          const value = data[key];
          const label = key.charAt(0).toUpperCase() + key.slice(1);
  
          // Handle description specifically for truncation
          if (key.toLowerCase() === "description" && typeof value === "string") {
            return (
              <Descriptions.Item key={key} label={label}>
                {truncateText(value)}
              </Descriptions.Item>
            );
          }
  
          // For nested objects or arrays
          return (
            <Descriptions.Item key={key} label={label}>
              {renderNestedContent(value)}
            </Descriptions.Item>
          );
        })
      : null;
  };
  
  
  return (
    <>
      <Drawer
        title={title}
        visible={isVisible}
        onClose={handleCancel}
        width={480} // Adjust the width as needed
        footer={null} // Disable default footer
      >
        {data ? (
          <Descriptions bordered column={1}>
            {renderDescriptionItems()}
          </Descriptions>
        ) : (
          <p>No data available</p>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          {footerButtons.map((buttonLabel) => (
            <Button
              key={buttonLabel}
              onClick={() => onButtonClick(buttonLabel, data)}
              style={{ marginLeft: 8 }}
            >
              {buttonLabel}
            </Button>
          ))}
        </div>
      </Drawer>

      {/* Drawer for displaying full description */}
      <Drawer
        title="Full Description"
        visible={isDescriptionDrawerVisible}
        onClose={() => setIsDescriptionDrawerVisible(false)}
        width={400} // Adjust the width as needed for the description drawer
      >
        <p>{fullDescription}</p>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          <Button onClick={() => setIsDescriptionDrawerVisible(false)}>Close</Button>
        </div>
      </Drawer>
    </>
  );
};

export default GenericViewDrawer;
